import { FIELD_REQUIRED } from 'form/validation/validationMessages'
import * as Yup from 'yup'

export const UpdateLinkSchema = Yup.object().shape({
    label: Yup.string().required(FIELD_REQUIRED),
    // Allow null or empty string for Unassigned
    assignedTo: Yup.string().notRequired().nullable(),
})
